import React, {useCallback, useEffect, useMemo, useRef} from 'react';
import {useDispatch} from 'react-redux';
import {playAudio, stopAudio, toggleAudio, playCorrectSound, playIncorrectSound} from 'actions/audioActions';
import {s3bucketPublicURL, imagesURL} from 'config';
import {mathRodsFeedbackAudioUrl} from './feedback-media-url.mjs';
import MathRodsGameModal from './MathRodsGameModal';
import {mathRodsLearnerText} from './localization.mjs';

// MathRods-only feedback facade. Shared GameFeedback and audioActions remain
// exactly as in original. Private popover supports inherited absolute audio.
export default function MathRodsFeedback({feedback, versionType='', contentFolder='', language='en', translate, onClose}) {
  const dispatch=useDispatch();
  const onCloseRef=useRef(onClose);
  onCloseRef.current=onClose;
  const source=useMemo(()=>mathRodsFeedbackAudioUrl(feedback?.audioSrc || feedback?.audio, {
    contentFolder, versionType, s3bucketPublicURL,
  }),[feedback,versionType,contentFolder]);
  const finish=useCallback(()=>{if(source)stopAudio(source);onCloseRef.current?.();},[source]);
  useEffect(()=>{
    if(!feedback)return undefined;
    if(source)playAudio(source);
    else if(!feedback.specific) dispatch(feedback.isCorrect?playCorrectSound(language):playIncorrectSound(language));
    // As with the original feedback panel, recorded audio (or standard sound)
    // advances when it ends, while the close button always works as a fallback.
    document.addEventListener('audioEnded',finish,{once:true});
    return ()=>{document.removeEventListener('audioEnded',finish);if(source)stopAudio(source);};
  },[feedback,source,language,dispatch,finish]);
  if(!feedback || !feedback.specific)return null;
  const message=typeof feedback.text==='string'&&feedback.text.trim()
    ?feedback.text:mathRodsLearnerText(feedback.isCorrect?'Correct!':'Try again.',language);
  return <MathRodsGameModal compact containInViewport title={translate?.(950,'Feedback')||'Feedback'}
    buttons={[
      ...(source?[{ariaLabel:translate?.(0,'Speak')||'Speak',icon:`${imagesURL}/Images/Audio/audio_icon1.png`,clickHandler:()=>toggleAudio(source)}]:[]),
      {ariaLabel:translate?.(0,'Close')||'Close',icon:`${imagesURL}/Images/Help/Close50.png`,clickHandler:finish},
    ]}>
    <p role="status" aria-live="polite">{message}</p>
  </MathRodsGameModal>;
}
